module.exports = __webpack_public_path__ + "assets/37ee120edac08a6a1cc5e65896e9a22b.png";